import type { AIProviderId } from "../../shared/aiProviders";
import {
  IMAGE_TYPES,
  MAX_DOCUMENT_SIZE,
  MAX_IMAGE_SIZE,
  MAX_PDF_SIZE,
  attachmentSizeLimit as sharedAttachmentSizeLimit,
  resolveAttachmentMediaType as sharedResolveAttachmentMediaType,
} from "../../shared/attachmentPolicy";

export { IMAGE_TYPES, MAX_DOCUMENT_SIZE, MAX_IMAGE_SIZE, MAX_PDF_SIZE };
export const MAX_ATTACHMENTS = 5;

export function resolveAttachmentMediaType(
  file: Pick<File, "name" | "type">,
  providerId: AIProviderId
) {
  return sharedResolveAttachmentMediaType(file, providerId);
}

export function attachmentSizeLimit(mediaType: string) {
  return sharedAttachmentSizeLimit(mediaType);
}

export type PendingAttachment = {
  id: string;
  fileName: string;
  mediaType: string;
  sizeBytes: number;
  data: string | null;
  previewUrl: string | null;
};
